import { Component } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeSv from '@angular/common/locales/sv';
import localeEn from '@angular/common/locales/en';
import { Route, Router } from '@angular/router';
import { AuthGuard, CustomPageDisplayComponent, CustomPageResolverService } from 'gung-standard';
import { GungDashboardComponent } from 'gung-dashboard';
import { RefWelcomeComponent } from './components/pages/ref-welcome/ref-welcome.component';
import {
  JeevesCustomerDetailsComponent,
  JeevesOrderDetailsComponent,
  JeevesProductDetailsComponent,
  JeevesOpenOrdersComponent
} from 'gung-standard-jeeves';
import { RefCategoriesComponent } from './components/pages/ref-categories/ref-categories.component';
import { RefProductsComponent } from './components/pages/ref-products/ref-products.component';
import { RefCustomerDetailsComponent } from './components/pages/ref-customer-details/ref-customer-details.component';
import { RefCustomersComponent } from './components/pages/ref-customers/ref-customers.component';
import { RefProductDetailsComponent } from './components/pages/ref-product-details/ref-product-details.component';
import { RefJeevesOpenOrdersComponent } from './components/ref-jeeves-open-orders/ref-jeeves-open-orders.component';
import { environment } from './../environments/environment';
import { CapstoneOrderDetailsComponent } from './components/capstone/capstone-order-details/capstone-order-details.component';
import { RefOrderDetailsComponent } from './components/ref-order-details/ref-order-details.component';

@Component({
    selector: 'ref-root',
    template: '<ref-wrapper></ref-wrapper>',
    styleUrls: [],
    standalone: false
})
export class RefAppComponent {
  isRef = environment.projectName === 'ref';
  title = 'ref';

  constructor(router: Router, translate: TranslateService) {
    const config = router.config;

    const homePage: Route = this.isRef
      ? {
          path: '',
          component: CustomPageDisplayComponent,
          resolve: {
            pageComponent: CustomPageResolverService
          },
          data: {
            pageName: 'home'
          },
          canActivate: [AuthGuard]
        }
      : {
          path: '',
          component: RefWelcomeComponent,
          canActivate: [AuthGuard],
          pathMatch: 'full'
        };

    router.resetConfig([
      homePage,
      {
        path: 'customers',
        component: RefCustomersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'customers/:customerId',
        component: RefCustomerDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'categories',
        component: RefCategoriesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'products',
        component: RefProductsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'product/:productId',
        component: RefProductDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders/:orderId',
        component:  this.isRef ? RefOrderDetailsComponent : CapstoneOrderDetailsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'open-orders',
        component: RefJeevesOpenOrdersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'statistics',
        component: GungDashboardComponent,
        canActivate: [AuthGuard]
      },

      ...config
    ]);

    registerLocaleData(localeSv);
    registerLocaleData(localeEn);

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      console.log('language changed', event.lang);
      localStorage.setItem('selectedLanguage', event.lang);
    });
  }
}
